import React from "react";

const Status = () => {
  return <div></div>;
};

export default Status;
